// extracted by mini-css-extract-plugin
module.exports = {"container":"_24V_FHXo98OQO8avmZTjR4","emailsList":"_3ml8hCj1idgQHa2tvnaHS9","item":"_2BjimCkthc1zQ4wDTAxPTk","dot":"_12nwk74e9IF9Xaej5YAWHT"};